import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as moment from 'moment';
// material
import {
  Grid,
  Container,
  Stack,
  Typography,
  Button,
  Box,
  Tabs,
  Tab,
  tabsClasses
} from '@mui/material';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import Rating from '@mui/material/Rating';
// components
import Page from '../../components/Page';
import Loader from '../../components/Loader';
import Iconify from '../../components/Iconify';
import ActionButtonReviews from './components/ActionButtonReviews';
import { createMarkup, decodeEntities } from 'src/Redux/helpers/generalHelper';
// -------------------------------Action-----------------------------------
import { allReviews } from 'src/Redux/actions/reviewsActions';
import { DataGrid } from '@mui/x-data-grid';
import CustomTable from 'src/components/CustomTable';

const Reviews = () => {
  const dispatch = useDispatch();
  const pageState = useSelector((state) => state.reviews.items);
  const [loading, setLoading] = useState(false);
  const [pageSections, setPageSection] = useState({
    data: []
  });
  const formData = pageState;
  const [selectedLang, setSelectedLang] = React.useState('us');
  const [selectedReviews, setSelectedReviews] = React.useState([]);
// Searchable Filters
  const [platform, setPlatform] = React.useState([]);
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    const lang = reviewsByLanguage[newValue];
    setSelectedLang(lang);
  };
  useEffect(() => {
    setPageSection({
      ...formData
    });
  }, [pageState.reviews]);

  useEffect(() => {
    const fetchData = () => {
      try {
        setLoading(true);
        setTimeout(() => {
          dispatch(allReviews());
          setLoading(false);
        }, 1000);
      } catch (error) {
        setLoading(true);
      }
    };
    fetchData();
  }, []);
  useEffect(()=>{
    const reviews= pageState.reviews?.filter((item)=> item.lang === selectedLang );
    const platformData=reviews?.map(item=>({
      ...item,
      targetPg: item.isHomePg ? 'Home Page' : 'Service Page',
      status: item.active === true ? 'Active' : 'In-Active'
    }));
   setSelectedReviews(reviews);
   setPlatform(platformData);
  },[selectedLang,pageState]);

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    };
  }
  
  const reviewsByLanguage=['us','de','es','fr','it'];
  const columns = [
      { 
        field: 'isHomePg', 
        headerName: 'Target Page', width: 106,
        renderCell: (rowData) => <>{rowData.row.isHomePg ? 'Home Page': 'Service Page' }</>
       },
      { 
        field: 'serviceName', 
        headerName: 'Service Name',
        width: 120,
        renderCell: (rowData) => <>{rowData.row.serviceName || 'N/A'}</>
      },
      { field: 'categoryName', headerName: 'Category Name', width: 160, renderCell: (rowData) => <>{rowData.row.categoryName || 'N/A'}</> },
      { field: 'authorEmail', headerName: 'Author Email', width: 150 },
      { field: 'review', headerName: 'Review', width: 220 },
      { field: 'rating', headerName: 'Rating', width: 150,
        renderCell: (rowData) => <Rating name="simple-controlled" value={rowData.row.rating} readOnly />
      },
      {
        field: 'active',
        headerName: 'Status',
        width: 80,
        renderCell: (rowData) => <>{rowData.row.active === true ? 'Active' : 'In-Active'}</>
      },
      {
        field: 'action',
        headerName: 'Action',
        width: 80,
        renderCell: (rowData) => <ActionButtonReviews id={rowData.row._id} />
      }
    ];
  return (
    <Page title="Dashboard: Pages | Reviews">
      <Container>
        <Stack direction="row" justifyContent="space-between" mb={3} mr={1}>
          <Typography variant="h4" gutterBottom>
            All Testimonials
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            component={RouterLink}
            to="/dashboard/reviews/add-review"
            startIcon={<Iconify icon="eva:plus-fill" />}
          >
            Add Testimonial
          </Button>
        </Stack>
        <Grid container display="flex" alignItems="center" justifyContent="center">
          {loading ? <Loader /> : !pageState.reviews?.length > 0 && 'No Review Yet'}
          {!loading && (
            <>
              <Box sx={{ width: '100%' }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons
                  aria-label="visible arrows tabs example"
                  sx={{
                    [`& .${tabsClasses.scrollButtons}`]: {
                      '&.Mui-disabled': { opacity: '0.3' }
                    }
                  }}
                >
                  { reviewsByLanguage.map((lang, index) => (
                    <Tab label={lang.toUpperCase()} key={lang} {...a11yProps(index)} />
                  ))}
                </Tabs>
              </Box>
              {loading ?
               <Loader/>:
             <>
              
                 {selectedReviews ? <CustomTable
                    key={selectedLang}  
                    searchPlaceholder="Search..."
                    tableHeading="for Reviews"
                    platform={platform}
                    rows={selectedReviews}
                    setRows={setSelectedReviews}
                    rowId={(row) => row._id}
                    columns={columns}
                    loading={loading}
                    data={platform?.length ? platform?.length : 'No Data'} // For No Data
                  />:null
                 }
                </>
              }
              
            </>
          )}
        </Grid>
      </Container>
    </Page>
  );
};
export default Reviews;
